import isNil from 'lodash/isNil';
import { ROUTING_CLI_RECOMMEND_MESSAGE } from '@/constants/netdevice';
import { columnDefault } from '@/constants/table';
import msgUtil from '@/utils/message';
import { getValueAfterCheckEmpty } from '@/utils/string';
import netdeviceConfigApi from '@/api/config/netdevice/netdevice-info';
import WExcecuteCliScriptButton from '@/views/config/node/netdevice/components/ExcecuteCliScriptButton';

const dataTypeData = {
  snmp: {
    value: 'SNMP',
    label: 'SNMP',
  },
  cli: {
    value: 'CLI',
    label: 'CLI',
  },
};

export default {
  components: {
    WExcecuteCliScriptButton,
  },
  data() {
    return {
      ROUTING_CLI_RECOMMEND_MESSAGE,
      snmpLoading: false,
      cliLoading: false,
      tableData: [],
      isCli: false,
      dataTypeData,
      dataType: null,
      tmpDataType: null,
      scriptResult: null,
      checkDatetime: null,
      columnDefault,
      columns: [
        {
          prop: 'ipRouteDest',
          label: '도착지 IP 주소',
          headerAlign: 'center',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'ipRouteIfIndex',
          label: '인터페이스 인덱스',
          headerAlign: 'center',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'ipRouteNextHop',
          label: '다음 홉 IP 주소',
          headerAlign: 'center',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'ipRouteType',
          label: '라우트 타입',
          headerAlign: 'center',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'ipRouteProto',
          label: '프로토콜',
          headerAlign: 'center',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'ipRouteMask',
          label: '넷마스크',
          headerAlign: 'center',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'ipRouteMetric1',
          label: '메트릭',
          sortable: true,
          showOverflowTooltip: true,
          headerAlign: 'center',
          width: 100,
          formatter: this.formatterForIpRouteMetric,
        },
      ],
      showSearchTool: false,
    };
  },
  methods: {
    /**
     * 라우팅 데이터를 조회한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadData() {
      // override
    },
    /**
     * 네트워크 장비의 라우팅 스냅샷 타입을 조회한다.
     * @author Ju
     * @return {[type]} [description]
     */
    getRoutingSnapshotTypeOfObj(objId) {
      netdeviceConfigApi.getRoutingSnapshotTypeOfObj(objId).then((response) => {
        if (response.data.success && !isNil(response.data.data)) {
          const snapshotType = response.data.data;
          this.dataType = snapshotType;
          this.tmpDataType = this.dataType;
          this.isCli = snapshotType === this.dataTypeData.cli.value;
        } else {
          this.dataType = this.dataTypeData.snmp.value;
          this.tmpDataType = this.dataType;
          this.isCli = false;
        }
      }).catch(() => {
        this.dataType = this.dataTypeData.snmp.value;
        this.tmpDataType = this.dataType;
        this.isCli = false;
      });
    },
    /**
     * SNMP를 통해 라우팅 정보를 조회한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadDataBySnmp() {
      // override
    },
    /**
     * CLI로 라우팅 데이터를 조회한다.
     * @author Ju
     * @return {[type]} [description]
     */
    loadDataByCli() {
      if (this.$refs.cliScriptButton) {
        this.$refs.cliScriptButton.excecuteScript();
      } else {
        this.$nextTick(() => {
          this.$refs.cliScriptButton.excecuteScript();
        });
      }
    },
    /**
     * 데이터 로드 실패 처리
     * @author Ju
     * @return {[type]} [description]
     */
    failToLoad() {
      // override
    },
    /**
     * 스크립트 수행 완료 이벤트 핸들러
     * @author Ju
     * @param  {[type]} success [description]
     * @param  {[type]} data    [description]
     * @param  {[type]} message [description]
     * @return {[type]}         [description]
     */
    completeExecuteScript(success, data, message) {
      // override
      this.cliLoading = false;
      if (success) {
        this.scriptResult = data;
        if (!isNil(message)) {
          this.$message(message);
        }
      } else {
        this.$message(msgUtil.getCustomResultMsgData(message, false));
      }
    },
    /**
     * 메트릭 formatter
     * @author Ju
     * @param  {[type]} row    [description]
     * @param  {[type]} column [description]
     * @param  {[type]} value  [description]
     * @return {[type]}        [description]
     */
    formatterForIpRouteMetric(row, column, value) {
      if (value === '-1') {
        return '미사용';
      }
      return value;
    },
    /**
     * 헤더 검색 버튼 클릭 이벤트 핸들러
     * @author Ju
     * @return {[type]} [description]
     */
    onShowSearchToolButtonClick() {
      this.showSearchTool = !this.showSearchTool;
    },
    /**
     * 테이블 데이터 빈값 확인
     * @author Yang
     * @param  {Object} row
     * @param  {Object} column
     * @param  {String/Number} valu
     */
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    /**
     * 데이터 타입 변경 이벤트 핸들러
     * @author Ju
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     */
    onDataTypeChange(value) {
      if (this.isCli && value === this.dataTypeData.snmp.value) {
        const h = this.$createElement;
        const message = h('span', null, [
          h('div', null, ROUTING_CLI_RECOMMEND_MESSAGE),
          h('div', null, 'SNMP로 조회하시겠습니까?'),
        ]);
        this.$confirm(...msgUtil.getCustomConfirmData(message)).then(() => {
          this.dataType = value;
        }).catch(() => {
          this.tmpDataType = this.dataTypeData.cli.value;
        });
      } else {
        this.dataType = value;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/config/netdevice-routing-view.js